import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/fontawesome-free-solid';
import PropTypes from 'prop-types';
import {withSize} from 'react-sizeme';


class Slave extends React.Component {
    state = {
        open: false,
        message: false,
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.masterData !== undefined) {
            this.setState({message: false});
        }
    }

    openBox = () => {
        if (this.props.masterData !== undefined) {
            this.setState(prevState => ({
                open: !prevState.open,
            }), this.removeBookingDataOnClose);
        } else {
            this.setState({message: true});
        }
    }

    removeBookingDataOnClose = () => {
        const {onClickSchedule} = this.props;
        const {open} = this.state;


        if (!open) {
            onClickSchedule(undefined);
        }
    }


    render() {
        const {
            showBeforeOrAfter, resourceName, lang, children, size,
        } = this.props;
        const {open, message} = this.state;

        const openSign = open ? '-' : '+';

        const stylesForSlave = {};

        stylesForSlave.width = `${30}%`;

        const stylesForSlaveRight = {};

        stylesForSlaveRight.width = `${70}%`;

        let WrapperClass = 'panel card noLeftPad';

        if (size.width < 500) {
            WrapperClass = 'panel card noPadding';
        }

        return (

            <div className={WrapperClass}>
                <div
                    onClick={open ? null : this.openBox}
                    className="panel-heading noPadding"
                >
                    <div className="seven">
                        {open ? (
                            <div
                                className="pull-right"
                                style={{color: 'red'}}
                                onClick={this.openBox}
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    size="2x"
                                />
                            </div>

                        ) : null}


                        <h2 className="panel-title"><span className="expand">{openSign}</span>
                            <span className="fontBig">{lang.schedule.pickAlso} {resourceName}
              </span>
                        </h2>
                        {message ? (<span className="extra-message">{lang.schedule.pickPrimaryProductFirst}</span>) : ''}
                    </div>


                </div>

                {open && (
                    <div className="panel-body">

                        {showBeforeOrAfter && (
                            <React.Fragment>
                                {children[0]}
                                {children[1]}
                                {children[2]}
                                {children[4]}
                                {children[3]}
                            </React.Fragment>

                        )}

                        {showBeforeOrAfter === false && (
                            <div className="row is-flex" style={{paddingTop: `${1}%`}}>
                                <div style={stylesForSlave}>
                                    {children[2]}

                                </div>
                                <div style={stylesForSlaveRight}>
                                    {children[0]}
                                    {children[1]}
                                    {children[3]}

                                    {children[4]}


                                </div>
                            </div>

                        )}
                    </div>


                )}


            </div>


        );
    }
}


export default withSize()(Slave);



// WEBPACK FOOTER //
// ./src/components/Resource/components/Slave.jsx